// Lien de parrainage d'un animateur : /register?ref=CODE.
//
// Le code arrive par l'URL (depuis la landing, sur un autre domaine, ou par un
// lien partagé sur WhatsApp) et doit survivre à la navigation et au
// rechargement jusqu'à l'inscription. Il est gardé dans le localStorage avec
// sa date :
//   - le DERNIER lien cliqué l'emporte ;
//   - un lien de plus de 30 jours est ignoré (et effacé) ;
//   - il est effacé après une inscription aboutie.
//
// Le stockage peut manquer (navigation privée, stockage bloqué) : toute
// lecture ou écriture est protégée, l'inscription fonctionne sans.

const CLE = 'tc_parrainage_ref';

/** Durée de validité d'un lien de parrainage. */
export const DUREE_PARRAINAGE_MS = 30 * 24 * 60 * 60 * 1000;

export type Parrainage = {
  code: string;
  /** Instant de capture, en millisecondes. */
  le: number;
};

/** Forme normalisée d'un code saisi : majuscules, sans aucun espace. */
export const normaliserCodeApporteur = (saisi: string): string =>
  saisi.replace(/\s+/g, '').toUpperCase();

/**
 * Capture le paramètre ?ref d'une URL (location.search). Un code vide est
 * ignoré ; tout code présent remplace le précédent.
 */
export const capturerParrainage = (search: string, maintenant: number = Date.now()): void => {
  let ref: string | null = null;
  try {
    ref = new URLSearchParams(search).get('ref');
  } catch {
    return;
  }
  const code = normaliserCodeApporteur(ref ?? '');
  if (!code) return;
  try {
    window.localStorage.setItem(CLE, JSON.stringify({ code, le: maintenant } as Parrainage));
  } catch {
    // Stockage indisponible : le code reste dans l'URL de la page courante.
  }
};

/** Le code de parrainage en cours, ou null (absent, illisible ou expiré). */
export const lireParrainage = (maintenant: number = Date.now()): Parrainage | null => {
  let brut: string | null = null;
  try {
    brut = window.localStorage.getItem(CLE);
  } catch {
    return null;
  }
  if (!brut) return null;
  try {
    const p = JSON.parse(brut) as Parrainage;
    if (!p || typeof p.code !== 'string' || !p.code || typeof p.le !== 'number') {
      effacerParrainage();
      return null;
    }
    if (maintenant - p.le > DUREE_PARRAINAGE_MS) {
      effacerParrainage();
      return null;
    }
    return p;
  } catch {
    effacerParrainage();
    return null;
  }
};

/** Efface le code de parrainage (après une inscription aboutie). */
export const effacerParrainage = (): void => {
  try {
    window.localStorage.removeItem(CLE);
  } catch {
    // rien à effacer
  }
};
